import getAppName from './getAppName';
export function isGlobalNavAcademyMode(gates) {
  return getAppName() === 'LearningCenterUI' && !gates.includes('Academy:UnifiedAcademy:Navigation');
}